import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { styled } from '@material-ui/core/styles'
import { FC } from 'react'
import { useForm } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import useTranslate from '../../../i18n/useTranslate'

const CustomBtn = styled(Button)(() => ({
    minWidth: '0px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
}))

const SearchResearcher: FC<{}> = () => {
    const translate = useTranslate()
    const form = useForm()

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MyTextfield
                        name="keyword"
                        materialInputProps={{
                            label: `${translate.get('LABEL.SEARCH_BY_KEYWORD')}`,
                            placeholder: `${translate.get('LABEL.SEARCH_BY_KEYWORD')}`,
                            size: 'small',
                        }}
                        onEnter={form.submit}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Grid container justify="flex-end" spacing={2}>
                        <Grid item>
                            <Button
                                size={'large'}
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    form.reset()
                                    form.submit()
                                }}
                                color="default"
                            >
                                {translate.get('BUTTON.RESET')}
                            </Button>
                        </Grid>
                        <Grid item>
                            <CustomBtn
                                size={'large'}
                                fullWidth
                                variant="contained"
                                onClick={form.submit}
                                color="primary"
                            >
                                {translate.get('BUTTON.SEARCH')}
                            </CustomBtn>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default SearchResearcher
